import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';
import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {ConfigUtil} from '@mintdata-wsp/common/util/ConfigUtil';

export class AnalyticsController
{
    public initAllVendors():void
    {
        const {sampleDesign} = rootState.ui.visualDesigner;
        if( sampleDesign ) return;

        if( !ConfigUtil.useAnalytics() )
            return;

        // console.log('%c AnalyticsController => initAllVendors =', 'background:#0f0;color:#000;');

        commonControllers.analytics.logRocket.init();
        commonControllers.analytics.intercom.init();
        commonControllers.analytics.cobrowse.init();
        // commonControllers.analytics.upscope.init();
        commonControllers.analytics.mixpanel.init();

        if( ConfigUtil.isProd() )
        {
            commonControllers.analytics.hotjar.init();
        }
    }

    public trackEvent(_event:AnalyticsEventActions, value:any = {}):void
    {
        const {sampleDesign} = rootState.ui.visualDesigner;
        if( sampleDesign ) return;

        let event:AnalyticsEventActions = _event;

        const {googleAnalytics, intercom, mixpanel} = commonControllers.analytics;

        if( event === AnalyticsEventActions.TODO )
        {
            // console.log('%c *** AnalyticsController trackEvent =', 'background:#ff0;color:#000;', event);
            // console.log('%c value =', 'background:#ff0;color:#000;', value);
            return;
        }

        if( event === AnalyticsEventActions.WSP_PAGE_LOADED )
        {
            const {prevUrlLoaded} = rootState.navigation;

            const fromJoinPage = prevUrlLoaded.indexOf('/join/') !== -1 ||
                prevUrlLoaded.indexOf('/join-organization/') !== -1;

            if( fromJoinPage )
                event = AnalyticsEventActions.WSP_INVITE_NEW_USER_FIRST_PAGE_LOADED;

            value.from_page_url = prevUrlLoaded;
        }

        if( rootState.userSession )
        {
            const {currentUser} = rootState.userSession;

            if( !value.user_guid && currentUser ) value.user_guid = currentUser.uuid;
            if( !value.user_email && currentUser ) value.user_email = currentUser.email;
        }

        // all events have
        value.page_url = (window as Window).location.href;
        value.page_title = (document as Document).title;

        // console.log('%c *** AnalyticsController trackEvent =', 'background:#f30;color:#000;', event);
        // console.log('%c value =', 'background:#f60;color:#000;', value);

        googleAnalytics.gtag(event, value);
        intercom.trackEvent(event, value);
        mixpanel.track(event, value);
    }
}
